import { Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { formatDateString, formatTimeString } from '@mangovoice/core'

const AgentStatusDateHeader = () => {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    // Update time every minute
    const interval = setInterval(() => {
      setNow(new Date())
    }, 60000)

    return () => clearInterval(interval)
  }, [])

  const timeString = formatTimeString(now)
  const dateString = formatDateString(now, { weekday: 'long' })

  return (
    <Flex
      padding={'1.75rem'}
      alignItems={'flex-start'}
      gap={'0.5rem'}
      alignSelf={'stretch'}
      borderRadius={'0.5rem'}
      border={'1px solid var(--Gray-Gray400, #E5E5EE);'}
      background={'var(--Gray-Gray100, #FAFAFC);'}
    >
      <Flex alignItems={'flex-end'} gap={'1.5rem'} flex={'1 0 0'}>
        <Text
          fontSize={'2rem'}
          fontWeight={'800'}
          lineHeight={'2.5rem'}
          color={'var(--Gray-Gray1300, #1D1D30)'}
        >
          {timeString}
        </Text>
        <Text
          fontSize={'2rem'}
          fontWeight={'400'}
          lineHeight={'2.5rem'}
          color={'var(--Gray-Gray1300, #1D1D30)'}
        >
          {dateString}
        </Text>
      </Flex>
    </Flex>
  )
}

export default AgentStatusDateHeader
